import { ApiTable } from "@/shared/api/table/api-table";
import { useUiStore } from "@/shared/stores/uiStore";

interface UseTableDeletionProps {
  onDeleteSuccess: () => void;
  showToast: (
    message: string,
    type: "success" | "error",
    duration?: number,
  ) => void;
}

export const useTableDeletion = ({
  onDeleteSuccess,
  showToast,
}: UseTableDeletionProps) => {
  const { openModal, closeModal } = useUiStore();

  const confirmDelete = async (tableId: string) => {
    try {
      const tableApi = new ApiTable();
      await tableApi.deleteTable(tableId);
      showToast("Таблица успешно удалена", "success", 4000);
      onDeleteSuccess();
    } catch {
      showToast("Ошибка удаления таблицы", "error", 4000);
    } finally {
      closeModal();
    }
  };

  const handleDeleteRequest = (id: string) => {
    openModal("CONFIRMATION", {
      message: "Вы уверены, что хотите удалить таблицу?",
      onConfirm: () => confirmDelete(id),
    });
  };

  return { handleDeleteRequest };
};
